export default {"src":"/_next/static/image/public/images/ic_doctor_image_3.63f72d5a0b445d768914801e99cb4446.svg","height":61,"width":58};